// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 // urlService: 'http://52.55.216.103/rentastesting/api/',
  urlCidi:'http://52.55.216.103/api.cidisigemyt/api/cidi/logueoCiDi',
  //urlCidi:'http://localhost:16638/api/cidi/logueoCiDi',
  urlService:'https://www.sigemyt.com/emisiondeudamlcapi/api/',
 // urlReporte: 'http://52.55.216.103/ReportestestingAPI/api/INGRESOS/',
  urlReporte:'https://www.sigemyt.com/reportesapi/api/INGRESOS/',
  urlPagos360: 'https://www.sigemyt.com/cajaAPI/api/pagos360/',
  codigoJur: 2417,
  urlProveedores:'http://52.55.216.103/proveedoresemisioneswebapi/api/Proveedor/',
  
  // codigoJur: 2389,
 // codigoJur: 2421,
 //https://www.sigemyt.com/emisiondeudaemb/app/views/Inmuebles/Inmuebles.html
  //urlportal: 'http://52.55.216.103/portaltesting/#!/login',
  urlportal:'https://www.sigemyt.com/mlc/#!/login',
 // urlddjj:'http://52.55.216.103/ingresostesting/inicio.aspx'
   urlddjj:'https://www.sigemyt.com/ingresosmlc/Inicio.aspx'
};


/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
